"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsContextDefaultValue = exports.translationsContext = exports.TranslationsProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const translationsContextDefaultValue = exports.translationsContextDefaultValue = {
  modalTitle: 'Share and Copy',
  openWeChatClickDiscover: 'OpenWeChatClickDiscover',
  shareToWeChat: 'shareToWeChat',
  copy: 'Copy link',
  linkCopied: 'Link copied'
};
const translationsContext = exports.translationsContext = /*#__PURE__*/(0, _react.createContext)(translationsContextDefaultValue);
const {
  Provider
} = translationsContext;
const TranslationsProvider = ({
  children,
  value
}) => value ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
  value: value,
  children: children
}) : children;
exports.TranslationsProvider = TranslationsProvider;
